module.exports = __webpack_public_path__ + "static/media/star-of-david.9ced92b0.svg";